import React from "react";
import { ReactComponent as WarningIcon } from "../../assets/images/dashboard-warning-icon.svg";
import { List } from "antd";

const NotificationItem = ({ notifications }) => {  

  return (
    <List
      dataSource={notifications.slice(0, 10)}
      renderItem={(item) => (
        <List.Item>
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "flex-start",
            }}
          >
            <WarningIcon />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "05px",
              }}
            >
              <span>{item.heading}</span>
              <p
                style={{
                  color: "#BDBDBD",
                  fontSize: "13px",
                  margin: 0,
                }}
              >
                {item.subHeading}
              </p>
            </div>
          </div>
          <a>{item.action}</a>
        </List.Item>
      )}
    />
  );
};

export default NotificationItem;
